export default "/images/vendor/flag-icon-css/flags/1x1/bo.svg?41d4956b765a5197a2a76aaf71787794";